/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable @typescript-eslint/prefer-readonly */
import { Api } from '@technology/web3d/dist/esnext/Api.js';
import { Model } from '@technology/web3d';
import { TileViewer } from './qm-tile-viewer';
import { QuantizedMeshSettings } from '../config/qm-settings';
import { QmDecoder } from '../processing/qm-decoder';

export class QuantizedMeshTileViewerModel extends Model {
  private tileViewer: TileViewer;
  private qmDecoder!: QmDecoder;

  override isLoading(): boolean {
    return this.tileViewer.isLoading();
  }

  get visible(): boolean {
    return this.root.visible;
  }

  set visible(visible: boolean) {
    if (!visible && this.root.visible) {
      this.root.visible = visible;
    } else if (visible && !this.root.visible) {
      this.root.visible = visible;
    }
    this.api.renderingManager?.redraw();
  }

  private updateBoundingBox(): void {
    this.boundingBox.next(this.boundingBox.value.copy(this.tileViewer.box));
  }

  constructor(
    private mapSettings: QuantizedMeshSettings,
    private api: Api,
    decodeWorkerUrl: string
  ) {
    super(mapSettings.options.modelId);

    this.qmDecoder = new QmDecoder(
      decodeWorkerUrl,
      this.mapSettings.tileFetcher.fetcher
    );

    this.tileViewer = new TileViewer(
      this.root,
      this.mapSettings.tileFetcher,
      this.qmDecoder
    );
    this.updateBoundingBox();
  }

  createMesh(tile: { x: number; y: number; z: number }): void {
    void this.tileViewer.createMesh(tile);
  }
}
